import { DialogActions, DialogContent, DialogContentText, Grid, DialogTitle, IconButton, TextField } from '@mui/material';
import MDButton from 'components/MDButton';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch } from 'react-redux';
import { addProductUnit } from '../../redux/slices/subtraitSlice';
import { openSnackbar } from '../../redux/slices/common';
import { closeCustomModalDialog } from '../../redux/slices/modalSlice';

export default function AddNewUnitModal({ closeModal }) {
  const { modalData,} = useSelector(state => state.modal);
  const { fetchUnitListingData = () => { } , formData, setFormData} = modalData
  const dispatch = useDispatch()
  const [newFormData, setNewFormData] = useState({
    unit: '',
    label: ''
  })

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewFormData({
      ...newFormData,
      [name]: value
    })
  }

  const showError = (message, errorType) => {
    if (errorType === 'success') {
      dispatch(openSnackbar({ content: message, color: 'success', icon: 'check' }));
    }
    if (errorType === 'error') {
      dispatch(openSnackbar({ content: message, color: 'error', icon: 'warning' }));
    }
  };

  const handleSave = () => {
    dispatch(addProductUnit(newFormData)).unwrap()
      .then(res => {
        showError(res.message, 'success')
        dispatch(closeCustomModalDialog());
          setFormData({
            ...formData,
            unit:newFormData.unit, // Set the `unit` field to the new unit
          });
        fetchUnitListingData()
      }).catch((err) => {
        showError(err?.message, 'error');
      })
  }

  return (
    <>
      <DialogTitle id='draggable-dialog-title' display='flex' alignItems='center' justifyContent='space-between'>
        Add New Unit
        <IconButton onClick={closeModal} edge='end' size='small'>
          <CloseIcon fontSize='medium' />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Grid container alignItems="center" spacing={1} pt={1}>
            <Grid item xs={12} sm={12} md={6}>
              <TextField
                fullWidth
                name="unit"
                label="Add Unit"
                value={newFormData.unit}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <TextField
                fullWidth
                name="label"
                label="Add Label"
                value={newFormData.label}
                onChange={handleInputChange}
              />
            </Grid>
          </Grid>
        </DialogContentText>
      </DialogContent>
      <DialogActions className='footer-modal' style={{ marginBottom: "12px" }}>
        <MDButton
          onClick={closeModal}
          sx={{ minWidth: '160px' }}
          type='button'
          variant='outlined'
          color='dark'
        >
          Cancel
        </MDButton>
        <MDButton
          onClick={handleSave}
          sx={{ minWidth: '160px' }}
          color="primary"
          type='button'
          variant='contained'
        >
          Save
        </MDButton>
      </DialogActions>
    </>
  );
}